import { useQuery, UseQueryOptions } from 'react-query';

import { getJson } from '@zapier/toolbox-browser-fetch';

import { ZAPIER_APP_BASE_URL } from 'app/common/constants';
import { useNotify } from 'app/developer-v3/hooks';

import type { DeployKey } from 'app/developer-v3/types/deployKey';

const QUERY_KEY_PREFIX = 'query-deploy-keys';
const getQueryKey = () => QUERY_KEY_PREFIX;

function formatResponseBody(body: any): DeployKey[] {
  const { objects } = body;

  return (objects ?? [])
    .filter((key: any) => key.active)
    .map((key: any) => ({
      active: key?.active,
      date: key?.date,
      id: key?.id,
      key: key?.key,
    }));
}

function useQueryActiveDeployKeys(
  options?: UseQueryOptions<DeployKey[], Error, DeployKey[]>
) {
  const queryKey = getQueryKey();
  const notify = useNotify();

  const url = new URL('/api/platform/cli/keys', ZAPIER_APP_BASE_URL);

  const query = useQuery({
    queryKey,
    queryFn: async () => formatResponseBody(await getJson(url.href)),
    onError: async (error: any) => notify.failure(error.message, queryKey),
    ...options,
  });

  const { data, ...rest } = query;

  return { ...rest, keys: data, queryKey };
}

export default useQueryActiveDeployKeys;
export { getQueryKey, QUERY_KEY_PREFIX };
